import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { PlanInfoResponse } from '@/types/api/mypage/planInfo';

/** 契約プラン情報取得APIのURL */
const url = ApiUrl.Read.PLAN_INFO;

/**
 * 契約プラン情報取得APIの呼び出しフック
 * SigV4署名付きGETリクエストで契約プラン情報（プランコード・ステータス・契約期間等）を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetPlanInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<PlanInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetPlanInfo;
